import { CONFIG } from '../utils/config';

/**
 * Load Interaction Studio (Evergage) tracking script
 * This should be called once during application initialization
 */
export const loadInteractionStudio = () => {
  if (!CONFIG.REACT_APP_INTERACTION_STUDIO_LIB) {
    console.warn('Interaction Studio library URL not configured');
    return;
  }

  // Check if script already loaded
  const existingScript = document.querySelector(`script[src="${CONFIG.REACT_APP_INTERACTION_STUDIO_LIB}"]`);
  if (existingScript) {
    console.log('Interaction Studio script already loaded');
    return;
  }

  console.log('Loading Interaction Studio script...');
  
  const scriptTagBeacon = document.createElement('script');
  scriptTagBeacon.async = true;
  scriptTagBeacon.src = CONFIG.REACT_APP_INTERACTION_STUDIO_LIB;
  document.body.appendChild(scriptTagBeacon);
};
